import { LeadPayments } from '@/api/types/crm/crm.types'
import moment from 'moment'

export const formatPrice = (num: number): string => {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

export const getLatestActivePayment = (
  payments: LeadPayments['directions'][number]['payments'] | undefined,
) => {
  if (!payments?.length) {
    return undefined
  }

  const active = payments.filter((p) => p.status !== 0)
  const list = active.length > 0 ? active : payments

  return list.reduce(
    (latest, current) =>
      moment(current.created_at).isAfter(moment(latest.created_at))
        ? current
        : latest,
    list[0],
  )
}
